<template>
  <div class="fullscreen-detail">
    <van-nav-bar
      :title="this.$route.meta.title"
      left-text="返回"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
    <router-view class="detail-content"></router-view>
  </div>
</template>
<script>
import { NavBar as VanNavBar } from "vant";

export default {
  name: "fullscreen-layout",
  components: {
    VanNavBar
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss">
.fullscreen-detail {
  .van-nav-bar {
    padding-top: 20px;
  }
  .detail-content {
    padding-top: 86px;
  }
}
</style>
